import mapProps from 'recompose/mapProps';
import SkipTheQueue from './SkipTheQueue';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { withFormik } from 'formik';
import { withRouter } from 'react-router';
import { expediteOrder } from '../../../facades/eagle/user';
import { addFlashMessageError } from '../FlashMessages/duck';
import { connect } from 'react-redux';
import { withUserOrders } from '../../data-providers/orders';
import when from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import scrollTo from '../../utils/scrollTo';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import withCountry from '../../hocs/withCountry';
import { localiseUrl } from 'src/common/utils/format-localised-url';

const enhance = compose(
  withUserOrders,
  connect(null, dispatch => ({
    flashError: error => dispatch(addFlashMessageError(error)),
  })),
  withRouter,
  withHandlers({
    handleCancel: props => e => {
      e.preventDefault();
      scrollTo('#order-details');
    }
  }),
  mapProps(({ primary, ...props }) => {
    const orderNumber = props.match.params.orderNumber;
    const currentOrder = props.userOrders.orders.find(order => order.id === orderNumber) || {};
    return {
      ...primary,
      ...props,
      orderNumber,
      currentOrder,
      helpButtonUrl: replaceTextWithValues(primary.helpButtonUrl, { number: orderNumber })
    };
  }),
  withCountry,
  when(props => !props.currentOrder.isOpen, renderNothing, c => c),
  withFormik({
    mapPropsToValues: () => ({
      confirmed: false,
    }),
    handleSubmit: (values, { props }) => {
      if (values.confirmed) {
        expediteOrder(props.orderNumber)
          .then(() => window.location = localiseUrl(props.country, '/orders'))
          .catch(err => {
            const errors = err.details.errors;
            errors.forEach(error => props.flashError(error.detail));
          });
      }
    },
  }),
);


export default enhance(SkipTheQueue);



// WEBPACK FOOTER //
// ./src/client/js/view/components/SkipTheQueue/index.js